export default __webpack_public_path__ + "static/media/5.581481ce.png";